import * as React from "react";
import useLicenseCheck from "license/useLicenseCheck";
import InvalidLicenseWidgetInfo from "search/InvalidLicenseWidgetInfo";
import AssocAssetsList from "./AssocAssetsList";
function AssocAssetsWidget({ assetIds, direction = "row", label = "Associated Assets:" }) {
  const { security } = useLicenseCheck();
  if (!(security == null ? void 0 : security.isValid)) return /* @__PURE__ */ React.createElement(InvalidLicenseWidgetInfo, { featureName: "Associated Assets", withoutIcon: true });
  return /* @__PURE__ */ React.createElement(AssocAssetsList, { assetIds, direction, label });
}
export default AssocAssetsWidget;
